import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import PictureComponent from "components/core/picture/picture-component";
import { FOOTER_LINK_CLICK } from "constants/bigbrain-event-types";
import { ENRICHED_FOOTER_LINKS, MONDAY_LOGO_SRC, ROOT_LINK } from "constants/links";
import PictureWithLinkComponent from "components/core/picture-with-link/picture-with-link-component";
import { StyledFooterCategoryComponent } from "./footer-category-component.scss";
import { normalizeUrl } from "/utils/url";
import { trackEvent } from "/services/bigbrain-service";
import { withGenericConfig } from "/contexts/generic-config-context";
const FooterCategoryComponent = (props)=>{
    const { title, translate, links, type, hasMondayLogoTitle } = props;
    const trackLinkClick = (event)=>{
        const { target } = event;
        const href = normalizeUrl(target.href);
        trackEvent(FOOTER_LINK_CLICK, {
            kind: href
        });
    };
    const mapLinkByType = ({ linkKey })=>{
        const link = links[linkKey];
        let href, icon, openInNewTab;
        switch(type){
            case ENRICHED_FOOTER_LINKS:
                icon = link === null || link === void 0 ? void 0 : link.icon;
                href = link === null || link === void 0 ? void 0 : link.href;
                openInNewTab = link === null || link === void 0 ? void 0 : link.openInNewTab;
                break;
            default:
                href = links[linkKey];
        }
        return {
            icon,
            href,
            openInNewTab
        };
    };
    const linkRenderer = (linkKey, index)=>{
        const link = mapLinkByType({
            linkKey
        });
        const { href, icon, openInNewTab } = link;
        return /*#__PURE__*/ _jsx("div", {
            className: "link",
            children: /*#__PURE__*/ _jsxs("a", {
                onClick: trackLinkClick,
                href: href,
                target: openInNewTab ? "_blank" : "_self",
                rel: "noreferrer",
                children: [
                    icon && /*#__PURE__*/ _jsx("span", {
                        children: /*#__PURE__*/ _jsx(PictureComponent, {
                            src: icon
                        })
                    }),
                    translate(linkKey)
                ]
            })
        }, index);
    };
    const linksRenderer = ()=>{
        return Object.keys(links).map(linkRenderer);
    };
    return /*#__PURE__*/ _jsxs(StyledFooterCategoryComponent, {
        className: "footer-category-component",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "footer-category-image-and-title-warpper",
                children: [
                    hasMondayLogoTitle && /*#__PURE__*/ _jsx("div", {
                        className: "monday-logo-wrapper",
                        children: /*#__PURE__*/ _jsx(PictureWithLinkComponent, {
                            src: MONDAY_LOGO_SRC,
                            className: "footer-monday-logo-image",
                            href: ROOT_LINK,
                            alt: "monday logo"
                        })
                    }),
                    title && /*#__PURE__*/ _jsx("div", {
                        className: "title",
                        children: translate(title)
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "links",
                children: linksRenderer()
            })
        ]
    });
};
export default withGenericConfig(FooterCategoryComponent);
